var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCnVDistantBirdFlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 765 164",
    width: 765,
    height: 164,
    role: "img",
    "aria-label": "Distant flock of twelve birds flapping in flight",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Distant animated bird flock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#050507"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 29) scale(0.62)",
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C29 23 20 12 7 3 C11 17 20 28 31 35 L38 37 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "-22 35 31; 28 35 31; -22 35 31",
    dur: "1.05s",
    begin: "0.00s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23 32 C29 27 37 26 45 29 L53 24 L64 22 L59 26 L54 28 C51 32 45 34 39 34 L32 36 L25 38 L17 38 L22 34 L11 36 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 29 C47 23 50 18 55 18 L59 19 L61 21 L66 22 L60 24 L56 23 C53 26 52 29 52 31 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 32 L13 27 L19 34 L27 35 Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C26 27 15 29 2 40 C15 38 26 39 36 36 L42 34 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "23 35 31; -20 35 31; 23 35 31",
    dur: "1.05s",
    begin: "-0.31s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70 6) scale(0.55)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C29 23 20 12 7 3 C11 17 20 28 31 35 L38 37 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "-22 35 31; 28 35 31; -22 35 31",
    dur: "1.18s",
    begin: "-0.17s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23 32 C29 27 37 26 45 29 L53 24 L64 22 L59 26 L54 28 C51 32 45 34 39 34 L32 36 L25 38 L17 38 L22 34 L11 36 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 29 C47 23 50 18 55 18 L59 19 L61 21 L66 22 L60 24 L56 23 C53 26 52 29 52 31 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 32 L13 27 L19 34 L27 35 Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C26 27 15 29 2 40 C15 38 26 39 36 36 L42 34 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "23 35 31; -20 35 31; 23 35 31",
    dur: "1.18s",
    begin: "-0.48s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130 48) scale(0.70)",
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C29 23 20 12 7 3 C11 17 20 28 31 35 L38 37 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "-22 35 31; 28 35 31; -22 35 31",
    dur: "1.31s",
    begin: "-0.34s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23 32 C29 27 37 26 45 29 L53 24 L64 22 L59 26 L54 28 C51 32 45 34 39 34 L32 36 L25 38 L17 38 L22 34 L11 36 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 29 C47 23 50 18 55 18 L59 19 L61 21 L66 22 L60 24 L56 23 C53 26 52 29 52 31 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 32 L13 27 L19 34 L27 35 Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C26 27 15 29 2 40 C15 38 26 39 36 36 L42 34 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "23 35 31; -20 35 31; 23 35 31",
    dur: "1.31s",
    begin: "-0.65s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(196 17) scale(0.60)",
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C29 23 20 12 7 3 C11 17 20 28 31 35 L38 37 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "-22 35 31; 28 35 31; -22 35 31",
    dur: "1.44s",
    begin: "-0.51s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23 32 C29 27 37 26 45 29 L53 24 L64 22 L59 26 L54 28 C51 32 45 34 39 34 L32 36 L25 38 L17 38 L22 34 L11 36 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 29 C47 23 50 18 55 18 L59 19 L61 21 L66 22 L60 24 L56 23 C53 26 52 29 52 31 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 32 L13 27 L19 34 L27 35 Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C26 27 15 29 2 40 C15 38 26 39 36 36 L42 34 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "23 35 31; -20 35 31; 23 35 31",
    dur: "1.44s",
    begin: "-0.82s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(259 66) scale(0.63)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C29 23 20 12 7 3 C11 17 20 28 31 35 L38 37 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "-22 35 31; 28 35 31; -22 35 31",
    dur: "1.57s",
    begin: "-0.68s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23 32 C29 27 37 26 45 29 L53 24 L64 22 L59 26 L54 28 C51 32 45 34 39 34 L32 36 L25 38 L17 38 L22 34 L11 36 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 29 C47 23 50 18 55 18 L59 19 L61 21 L66 22 L60 24 L56 23 C53 26 52 29 52 31 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 32 L13 27 L19 34 L27 35 Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C26 27 15 29 2 40 C15 38 26 39 36 36 L42 34 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "23 35 31; -20 35 31; 23 35 31",
    dur: "1.57s",
    begin: "-0.99s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(325 33) scale(0.73)",
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C29 23 20 12 7 3 C11 17 20 28 31 35 L38 37 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "-22 35 31; 28 35 31; -22 35 31",
    dur: "1.05s",
    begin: "-0.85s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23 32 C29 27 37 26 45 29 L53 24 L64 22 L59 26 L54 28 C51 32 45 34 39 34 L32 36 L25 38 L17 38 L22 34 L11 36 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 29 C47 23 50 18 55 18 L59 19 L61 21 L66 22 L60 24 L56 23 C53 26 52 29 52 31 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 32 L13 27 L19 34 L27 35 Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C26 27 15 29 2 40 C15 38 26 39 36 36 L42 34 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "23 35 31; -20 35 31; 23 35 31",
    dur: "1.05s",
    begin: "-1.16s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(390 9) scale(0.54)",
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C29 23 20 12 7 3 C11 17 20 28 31 35 L38 37 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "-22 35 31; 28 35 31; -22 35 31",
    dur: "1.18s",
    begin: "0.00s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23 32 C29 27 37 26 45 29 L53 24 L64 22 L59 26 L54 28 C51 32 45 34 39 34 L32 36 L25 38 L17 38 L22 34 L11 36 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 29 C47 23 50 18 55 18 L59 19 L61 21 L66 22 L60 24 L56 23 C53 26 52 29 52 31 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 32 L13 27 L19 34 L27 35 Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C26 27 15 29 2 40 C15 38 26 39 36 36 L42 34 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "23 35 31; -20 35 31; 23 35 31",
    dur: "1.18s",
    begin: "-0.31s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(450 53) scale(0.68)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C29 23 20 12 7 3 C11 17 20 28 31 35 L38 37 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "-22 35 31; 28 35 31; -22 35 31",
    dur: "1.31s",
    begin: "-0.17s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23 32 C29 27 37 26 45 29 L53 24 L64 22 L59 26 L54 28 C51 32 45 34 39 34 L32 36 L25 38 L17 38 L22 34 L11 36 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 29 C47 23 50 18 55 18 L59 19 L61 21 L66 22 L60 24 L56 23 C53 26 52 29 52 31 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 32 L13 27 L19 34 L27 35 Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C26 27 15 29 2 40 C15 38 26 39 36 36 L42 34 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "23 35 31; -20 35 31; 23 35 31",
    dur: "1.31s",
    begin: "-0.48s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(515 21) scale(0.58)",
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C29 23 20 12 7 3 C11 17 20 28 31 35 L38 37 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "-22 35 31; 28 35 31; -22 35 31",
    dur: "1.44s",
    begin: "-0.34s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23 32 C29 27 37 26 45 29 L53 24 L64 22 L59 26 L54 28 C51 32 45 34 39 34 L32 36 L25 38 L17 38 L22 34 L11 36 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 29 C47 23 50 18 55 18 L59 19 L61 21 L66 22 L60 24 L56 23 C53 26 52 29 52 31 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 32 L13 27 L19 34 L27 35 Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C26 27 15 29 2 40 C15 38 26 39 36 36 L42 34 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "23 35 31; -20 35 31; 23 35 31",
    dur: "1.44s",
    begin: "-0.65s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(578 63) scale(0.65)",
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C29 23 20 12 7 3 C11 17 20 28 31 35 L38 37 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "-22 35 31; 28 35 31; -22 35 31",
    dur: "1.57s",
    begin: "-0.51s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23 32 C29 27 37 26 45 29 L53 24 L64 22 L59 26 L54 28 C51 32 45 34 39 34 L32 36 L25 38 L17 38 L22 34 L11 36 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 29 C47 23 50 18 55 18 L59 19 L61 21 L66 22 L60 24 L56 23 C53 26 52 29 52 31 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 32 L13 27 L19 34 L27 35 Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C26 27 15 29 2 40 C15 38 26 39 36 36 L42 34 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "23 35 31; -20 35 31; 23 35 31",
    dur: "1.57s",
    begin: "-0.82s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(641 35) scale(0.60)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C29 23 20 12 7 3 C11 17 20 28 31 35 L38 37 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "-22 35 31; 28 35 31; -22 35 31",
    dur: "1.05s",
    begin: "-0.68s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23 32 C29 27 37 26 45 29 L53 24 L64 22 L59 26 L54 28 C51 32 45 34 39 34 L32 36 L25 38 L17 38 L22 34 L11 36 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 29 C47 23 50 18 55 18 L59 19 L61 21 L66 22 L60 24 L56 23 C53 26 52 29 52 31 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 32 L13 27 L19 34 L27 35 Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C26 27 15 29 2 40 C15 38 26 39 36 36 L42 34 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "23 35 31; -20 35 31; 23 35 31",
    dur: "1.05s",
    begin: "-0.99s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700 12) scale(0.48)",
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C29 23 20 12 7 3 C11 17 20 28 31 35 L38 37 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "-22 35 31; 28 35 31; -22 35 31",
    dur: "1.18s",
    begin: "-0.85s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23 32 C29 27 37 26 45 29 L53 24 L64 22 L59 26 L54 28 C51 32 45 34 39 34 L32 36 L25 38 L17 38 L22 34 L11 36 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 29 C47 23 50 18 55 18 L59 19 L61 21 L66 22 L60 24 L56 23 C53 26 52 29 52 31 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 32 L13 27 L19 34 L27 35 Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35 31 C26 27 15 29 2 40 C15 38 26 39 36 36 L42 34 Z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "23 35 31; -20 35 31; 23 35 31",
    dur: "1.18s",
    begin: "-1.16s",
    repeatCount: "indefinite"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnVDistantBirdFlock);
export default __webpack_public_path__ + "static/media/CnVDistantBirdFlock.2f1a917d0a953f183ce2ecafb29a691c.svg";
export { ForwardRef as ReactComponent };